/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  getBedAndBathText.ts
 */

import { splitOnMiddleDot } from '@zcode/nr-utils'
import type { Listable } from '@zcode/state-type'

type GetBedAndBathTextTypes = Pick<
  Listable,
  'bathroomTxt' | 'bedsBathsRangeTxt' | 'bedroomTxt' | 'isBuilding'
>

export const getBedAndBathText = ({
  bathroomTxt,
  bedsBathsRangeTxt,
  bedroomTxt,
  isBuilding,
}: GetBedAndBathTextTypes) => {
  let bedTxt
  let bathTxt
  if (isBuilding) {
    ;[bedTxt, bathTxt] = splitOnMiddleDot(bedsBathsRangeTxt)
  } else {
    bedTxt = bedroomTxt
    bathTxt = bathroomTxt
  }
  return [bedTxt, bathTxt] as const
}
